export default "__VITE_ASSET__HocBmVu$__"